import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const NatureService = {
    list: async (data) => axios.post(API_URL + "/nature/list", data).then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_URL + `/getNature/${id}`).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_URL + `/nature`, data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.post(API_URL + `/nature/${id}`, data).then(({data}) => data).catch((err) => { throw err }),

    destroy: async (id) => axios.delete(API_URL + `/nature/${id}`).then(({data}) => data).catch((err) => { throw err }),

    groups: async () => axios.get(`${API_URL}/nature/getNature/groups`).then(({data}) => data).catch((err) => { throw err }),

    getInterligation: async () => axios.get(API_URL + `/nature/get/interligationGroups`).then(({data}) => data).catch((err) => { throw err }),

    optionsName: async () => axios.get(API_URL + `/nature/get/allNames`).then(({data}) => data).catch((err) => { throw err }),

    getAllToSelect: async () => axios.get(API_URL + `/nature/getAllToSelect/natures`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    getJanitorialNatures: async () => axios.get(API_URL + `/nature/janitorial/natures`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    getOccurrencesDetailsNatures: async () => axios.get(API_URL + `/nature/getNature/getOccurrencesDetailsNatures`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    getAttendanceNatures: async () => axios.get(API_URL + `/nature/getNature/getAttendanceNatures`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    getAttendanceNatureGroups: async () => axios.get(API_URL + `/nature/getNature/getAttendanceNatureGroups`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    naturesSchedule: async () => axios.get(API_URL + `/nature/getNature/naturesSchedule`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    getNatureAllNames: async () => axios.get(API_URL + `/nature/get/allNames`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    getByBoGcm: async () => axios.get(API_URL + `/nature/get/byBoGcm`).then(({data}) => data.map(d => ({value: d.text, label: d.text, ...d}))).catch((err) => { throw err }),

    dispatchNatures: async () => axios.get(API_URL + `/nature/get/dispatchNatures`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),

    getNatureGroups: async () => axios.get(API_URL + `/nature/getNature/groups`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
    getSystemNatures: async () => axios.get(API_URL + `/nature/get/systemNatures`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
}

export default NatureService;
